import React from 'react';
import { useAlgo } from '../hooks/useAlgo';
import ConnectWalletMessage from './ConnectWalletMessage';
import TraitShuffle from './TraitShuffle';

const TraitShufflePage = () => {
  const { address } = useAlgo();

  if (!address) {
    return (
      <div className='flex justify-center mt-12'>
        <ConnectWalletMessage />
      </div>
    );
  }

  return (
    <div>
      <TraitShuffle />
    </div>
  );
};

export default TraitShufflePage;
